import request from '@/router/axios';

export const starorderconfirmrecordList = (current, size) => {
  return request({
    url: '/api/blade-sorder/starorderconfirmrecord/page',
    method: 'get',
    params: {
      current,
      size,
    }
  })
}
// 工作台-头部数据
export const workbenchTopData = params => {
  // console.log('post提交', params)
  return request({
      url: '/api/blade-stat/work/workOrderCnt',
      method: 'get',
      params
  })
}

// 工作台-工作信息统计
export const workInfoData = params => {
  // console.log('post提交', params)
  return request({
      url: '/api/blade-stat/work/workInfoForAll',
      method: 'get',
      params
  })
}

// 工作台-案件类型
export const caseTypeData = params => {
  // console.log('post提交', params)
  return request({
      url: '/api/blade-stat/work/crimeTypeMonthOfYear',
      method: 'get',
      params
  })
}

// export const caseTypeData = params => {
//   // console.log('post提交', params)
//   return request({
//       url: '/api/blade-stat/desk/caseTypeData',
//       method: 'get',
//       params
//   })
// }